import "./widgets.css";
import React from 'react'

const WidgetsIcon = ({icon, title}) => {
  return (
    <div className="widget-icon">
        <span className="icon">{icon}</span>
        <span className="title">{title}</span>
    </div>
  )
}

export default WidgetsIcon